export const buildLocationOpenWithUrl = (latitude: number, longitude: number) => {
    const isDesktop = !/Mobi|Android/i.test(navigator.userAgent);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    const geoUrl = `geo:${latitude},${longitude}`;

    return isDesktop ? googleMapsUrl : geoUrl
}

export const buildLocationNavigateToUrl = (latitude: number, longitude: number) => {
    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
}